import {ButtonBase} from '@mui/material';
import React from 'react';
import ClickableProps from './clickable.props';

export default function Clickable({
  children,
  ...buttonBaseProps
}: ClickableProps) {
  return <ButtonBase {...buttonBaseProps}>{children}</ButtonBase>;
}
